import React from "react";
import { NavLink } from "react-router-dom";
import "./_staticPages.scss";

export function AboutUsPage() {
  return (
    <section className="static-page-section">
      <div className="static-page-banner about-banner">
        <div className="container">
          <h1>About Popin</h1>
          <p>Discover how Popin helps brands create meaningful and lasting customer relationships.</p>
        </div>
      </div>
      <div className="container static-page-container">
        <div className="static-page-header">
          <h3>Powering Customer Engagement & Loyalty</h3>
        </div>
        <div className="static-page-card">
          <p>
            Popin CX platform is a{" "}
            <b>comprehensive customer engagement and loyalty platform</b>{" "}
            designed to help brands connect, engage, and retain
            customers through a unified ecosystem. It enables businesses to
            manage customer interactions, drive repeat purchases, and build
            long-term relationships all from a single, intuitive dashboard.
          </p>
          <p>
            Built for modern retail and consumer-focused businesses, Popin
            empowers brands with{" "}
            <b>omnichannel communication</b> capabilities across WhatsApp, SMS,
            email, RCS and digital touchpoints. By combining
            loyalty programs, campaign automation, digital receipts, and
            real-time customer insights, the platform helps deliver personalized
            experiences at every stage of the customer journey.
          </p>
          <p>
            With a strong focus on{" "}
            <b>simplicity, scalability, and affordability</b>, Popin is designed
            to make advanced CRM and engagement tools
            accessible to growing brands. It enables businesses to not only
            track and manage customer data but also convert insights into
            meaningful actions that drive engagement, retention, and revenue
            growth.
          </p>
          <p>
            At its core, Popin{" "}
            <b>bridges the gap between offline and digital experiences</b>,
            helping brands create seamless, data-driven customer journeys that
            enhance loyalty and maximize lifetime value.
          </p>
        </div>
      </div>
    </section>
  );
}

export function ContactUsPage() {
  return (
    <section className="static-page-section">
      <div className="static-page-banner contact-banner">
        <div className="container">
          <h1>Contact Us</h1>
          <p>
            Connect with the Popin team for demos, partnerships, and product
            support.
          </p>
        </div>
      </div>
      <div className="container static-page-container">
        <div className="static-page-header">
          <span className="page-tag">Contact Us</span>
          <h2>Let's Connect</h2>
          <p>
            Have questions or want to know more about Popin? Reach out and our
            team will be happy to help.
          </p>
        </div>
        <div className="static-page-card">
          <div className="contact-item">
            <h4>Phone</h4>
            <a href="tel:+918054576746">+91-8054576746</a>
          </div>
          <div className="contact-item">
            <h4>Email</h4>
            <a href="mailto:support@popinstores.com">support@popinstores.com</a>
          </div>
          <div className="page-action">
            <NavLink to="/" className="back-home-link">
              Back to Home
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
}

export function TermsConditionsPage() {
  return (
    <section className="static-page-section">
      <div className="static-page-banner legal-banner">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p>Website terms governing your use of POPIN platform and services.</p>
        </div>
      </div>
      <div className="container static-page-container">
        <div className="static-page-header">
          <span className="page-tag">Legal</span>
          <h2>POPIN Website Terms and Conditions</h2>
        </div>
        <div className="static-page-card legal-content-card">
          <p>
            Please read these Website Terms and Conditions carefully before
            registering on, accessing, browsing, downloading or using POPIN
            platform services. By continuing to use this website, you agree to
            be bound by these terms and any modifications introduced from time
            to time.
          </p>

          <h4>General Terms and Conditions</h4>
          <ul>
            <li>
              You must provide true, accurate, current and complete information
              during registration.
            </li>
            <li>
              You must maintain and update this information to keep it accurate
              and complete.
            </li>
            <li>
              If information is untrue, inaccurate, not current or incomplete,
              POPIN may terminate your account and refuse current or future use
              of the platform.
            </li>
            <li>You agree not to resell or transfer access to the platform.</li>
          </ul>

          <h4>Registration of Your Account</h4>
          <ul>
            <li>
              To use platform features (such as loyalty program, dashboard,
              campaign, etc.), you must create an account and provide requested
              details including name, gender, email, password, phone and
              billing/shipping details.
            </li>
            <li>
              By accepting these terms, you agree that POPIN may send alerts and
              promotional communications by SMS, email and push notifications.
            </li>
            <li>
              You confirm that you are 18 years or older and capable of agreeing
              to these terms.
            </li>
            <li>
              You are responsible for maintaining confidentiality of login
              credentials and all activities performed through your account.
            </li>
            <li>
              You must immediately report unauthorized access or security
              breaches and ensure proper logout after each session.
            </li>
            <li>
              POPIN may refuse access, terminate accounts, or edit/remove content
              without prior notice.
            </li>
            <li>
              Coupon/point redemption may be subject to retailer-specific terms,
              and POPIN is not responsible for losses or damages arising from
              coupon usage.
            </li>
            <li>
              Delivery of SMS/email/push alerts depends on service provider
              infrastructure; POPIN is not responsible for non-delivery, delays
              or distortion.
            </li>
          </ul>

          <h4>Limitation of Liabilities</h4>
          <p>
            POPIN and its employees, agents, affiliates, successors, assigns and
            service/content providers are not liable for direct, indirect,
            incidental, special or consequential damages arising from use of, or
            inability to access/use, the service.
          </p>

          <h4>Indemnity</h4>
          <p>
            You agree to defend, indemnify and hold POPIN and its affiliates
            harmless against claims, liabilities, costs and expenses (including
            reasonable attorneys' fees) arising from your use of the website.
          </p>

          <h4>Privacy</h4>
          <p>
            Your use of the platform is also governed by the POPIN Privacy
            Policy. Continued use of the site constitutes acceptance of the
            currently published Privacy Policy.
          </p>

          <h4>Intellectual Property</h4>
          <p>
            POPIN is the sole owner and/or authorized user of trademarks,
            service marks and copyrights appearing on this website. Copying or
            saving site screens/content is not permitted except where explicitly
            allowed.
          </p>

          <h4>Applicable Law and Jurisdiction</h4>
          <p>
            These terms are governed by laws of India. Disputes are subject to
            the jurisdiction of courts located at POPIN registered office in
            Gurgaon (HR), India.
          </p>

          <h4>Amendment</h4>
          <p>
            These terms may be updated from time to time. Your relationship with
            the platform is governed by the latest published version.
          </p>

          <h4>Communication with Us About Privacy</h4>
          <p>
            For privacy-related queries, contact:{" "}
            <a href="mailto:privacy@popinstores.com">privacy@popinstores.com</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export function PrivacyPolicyPage() {
  return (
    <section className="static-page-section">
      <div className="static-page-banner legal-banner">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How POPIN collects, uses, protects and manages your data.</p>
        </div>
      </div>
      <div className="container static-page-container">
        <div className="static-page-header">
          <span className="page-tag">Legal</span>
          <h2>POPIN Privacy Policy</h2>
        </div>
        <div className="static-page-card legal-content-card">
          <p>
            At POPIN, we are committed to protecting your personal and company
            information. We do not sell, rent, trade or distribute your personal
            information except as described in this policy.
          </p>

          <h4>Protecting Your Information</h4>
          <p>
            We use industry-recognized security safeguards, encryption and
            procedural controls to protect your information from loss, misuse,
            unauthorized access or alteration.
          </p>

          <h4>Information We May Collect</h4>
          <ul>
            <li>
              Personal details such as name, workplace details, email, address
              and phone number.
            </li>
            <li>System and browser data including IP address.</li>
            <li>
              Site activity data such as page views, click paths and interaction
              behavior.
            </li>
            <li>
              Cookies and web beacons to manage sessions and improve user
              experience.
            </li>
            <li>Survey responses, feedback and optional user interactions.</li>
          </ul>

          <h4>How We Use Information</h4>
          <ul>
            <li>
              To manage accounts and provide, improve and support products and
              services.
            </li>
            <li>
              To communicate service-related information and requested updates.
            </li>
            <li>
              To process billing and transactions related to purchased services.
            </li>
            <li>
              To analyze aggregate usage patterns and improve product
              performance.
            </li>
            <li>
              To send marketing/promotional content only as permitted and with
              applicable consent controls.
            </li>
          </ul>

          <h4>POPIN Services and Third Parties</h4>
          <p>
            We may engage trusted third parties for service delivery (such as
            analytics, communication and platform operations). Such parties are
            contractually restricted from using data for unrelated purposes.
            Third-party websites linked from POPIN have their own privacy
            policies.
          </p>

          <h4>Choices for Personal Information</h4>
          <ul>
            <li>
              You can opt out of non-essential promotional communications.
            </li>
            <li>
              You can manage cookie preferences in your browser settings.
            </li>
            <li>
              You may request access, correction or deletion of personal data,
              subject to legal/regulatory retention requirements.
            </li>
          </ul>

          <h4>Privacy Impact Assessment</h4>
          <p>
            POPIN performs privacy impact assessments across the data lifecycle
            to identify and reduce risks, ensure compliance and uphold data
            subject rights.
          </p>

          <h4>Data Subject Rights</h4>
          <ul>
            <li>Right to access personal data and processing purposes.</li>
            <li>Right to correction of inaccurate/incomplete data.</li>
            <li>
              Right to object to specific processing activities, including direct
              marketing.
            </li>
            <li>Right to request deletion and data portability.</li>
            <li>Right to withdraw consent for data processing.</li>
          </ul>

          <h4>Data Breach Notification</h4>
          <p>
            In case of a confirmed data breach, notification will be issued to
            affected data subjects and relevant authorities within 72 hours of
            reporting.
          </p>

          <h4>Data Retention and Disposal</h4>
          <p>
            Personal data is retained only as long as necessary for business,
            legal or regulatory requirements. Data is deleted or anonymized when
            no longer required.
          </p>

          <h4>Cross-Border Data Transfer</h4>
          <p>
            Data may be transferred across POPIN global offices, data centers,
            affiliates and authorized partners with adequate safeguards and
            applicable legal protections.
          </p>

          <h4>Changes to This Privacy Policy</h4>
          <p>
            This policy may be updated periodically due to operational,
            regulatory or legal requirements. Updated versions will be published
            on this page with appropriate notices.
          </p>

          <h4>Communication with Us About Privacy</h4>
          <p>
            For privacy-related queries, contact:{" "}
            <a href="mailto:privacy@popinstores.com">privacy@popinstores.com</a>
          </p>
        </div>
      </div>
    </section>
  );
}
